import BaseMessageHandler from '../BaseMessageHandler';
import { updateDataItem } from 'actions/getData';

export default class Team_DisableUser extends BaseMessageHandler {
  success = () => {
    const { dispatch, message } = this;
    dispatch(updateDataItem('teamUsers', 'id', message.payload));
  };
}
